import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface CommonState {
  isdeleteModalOpen: boolean;
  deleteId: number;
  isConfirmModalOpen: boolean;
  isModalOpen: boolean;
  modalMode: string;
  editData: any;
  showChangePasswordModal: boolean;
  metadata: any;
}

const initialState: CommonState = {
  isdeleteModalOpen: false,
  deleteId: 0,
  isConfirmModalOpen: false,
  isModalOpen: false,
  modalMode: '',
  editData: null,
  showChangePasswordModal: false,
  metadata: null,
};

const CommonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsdeleteModalOpen: state => {
      state.isdeleteModalOpen = !state.isdeleteModalOpen;
    },
    setIsConfirmModalOpen: state => {
      state.isConfirmModalOpen = !state.isConfirmModalOpen;
    },
    setIsModalOpen: state => {
      state.isModalOpen = !state.isModalOpen;
    },
    setDeleteId: (state, action: PayloadAction<number>) => {
      state.deleteId = action.payload;
    },
    setModalMode: (state, action: PayloadAction<string>) => {
      state.modalMode = action.payload;
    },
    setEditData: (state, action: PayloadAction<any>) => {
      state.editData = action.payload;
    },
    setShowChangePasswordModal: state => {
      state.showChangePasswordModal = !state.showChangePasswordModal;
    },
    setMetadata: (state, action: PayloadAction<any>) => {
      state.metadata = action.payload;
    },
  },
});

export const selectIsdeleteModalOpen = (state: RootState) =>
  state.common.isdeleteModalOpen;
export const selectIsConfirmModalOpen = (state: RootState) =>
  state.common.isConfirmModalOpen;
export const selectIsModalOpen = (state: RootState) => state.common.isModalOpen;
export const selectEditData = (state: RootState) => state.common.editData;
export const selectDeleteId = (state: RootState) => state.common.deleteId;
export const selectModalMode = (state: RootState) => state.common.modalMode;
export const selectShowChangePasswordModal = (state: RootState) =>
  state.common.showChangePasswordModal;
export const selectMetadata = (state: RootState) => state.common.metadata;

export const {
  setIsdeleteModalOpen,
  setDeleteId,
  setEditData,
  setModalMode,
  setIsConfirmModalOpen,
  setShowChangePasswordModal,
  setIsModalOpen,
  setMetadata,
} = CommonSlice.actions;

export default CommonSlice.reducer;
